import { useState } from "react";
import { UpdatesByDealerPopup } from "./UpdatesByDealerPopup";
import IconSVG from "../../../styles/svg-icons";

export function UpdatesByDealer() {
    const [popupVisible, setPopupVisible] = useState(false);
    
    return (
        <>
            <button className="btn btn-link" type="button" onClick={() => setPopupVisible(true)}>
                <IconSVG name="inventory" width={16} height={16} />
                Updates
            </button>
            {popupVisible && <UpdatesByDealerPopup onClose={() => setPopupVisible(false)} />}
        </>
    )
}